import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Title from "../components/common/Title";
import AppFrame from "./Appframe/AppFrame";
import * as actionCreators from "../actions/apps";
import DeleteIcon from "material-ui/svg-icons/action/delete-forever";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import AddIcon from "@material-ui/icons/Add";
import Switch from "@material-ui/core/Switch";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import Paper from "@material-ui/core/Paper";

import colors, { colorsV2 } from "../styles/colors";

import {
  sortableElement,
  sortableContainer,
  arrayMove,
} from "react-sortable-hoc";

import { filter, update } from "lodash";

const SortableItem = sortableElement(({ value, handleRemove, instruction }) => {
  return (
    <div
      style={{
        textDecoration: "none",
        listStyle: "none",
        width: "100%",
        border: "solid 1px grey",
        padding: 10,
        marginTop: 10,
        borderRadius: 7,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          margin: 0,
          padding: 0,
        }}
      >
        <span
          style={{
            fontSize: 16,
            fontFamily: "Poppins-Semibold",
            marginRight: 30,
          }}
        >
          {value.categoryName}
        </span>
        <div>
          <DeleteIcon
            onClick={() => {
              handleRemove(value.categoryId);
            }}
          />
          <MenuIcon />
        </div>
      </div>
      <div>
        <span
          style={{
            margin: 0,
            padding: 5,
            backgroundColor: colors.primary,
            color: colors.white,
            borderRadius: 5,
            fontSize: 12,
            fontFamily: "Poppins-Regular",
          }}
        >
          {value.groupName}
        </span>
      </div>
      <p style={{ margin: 0, fontSize: 12, color: colors.grey }}>
        {value.categoryDesc}
      </p>
    </div>
  );
});

const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});

const getInstructionsArray = (props) => {
  let ret = [];
  if (props.apps && props.apps.providerAppId) {
    props.apps.appTemplates[props.apps.providerAppId].groups.map((group) => {
      group.categories.map((inst) => {
        ret.push(inst);
        return true;
      });
    });
  }
  return ret;
};

const getSelectedInstructionsArray = (props, selectedProgram) => {
  let ret = [];

  if (selectedProgram && props.apps && props.apps.providerAppId) {
    const groups = props.apps.appTemplates[props.apps.providerAppId].groups;

    // First, collect all instructions into a lookup object by categoryId
    const instructionMap = {};
    groups.forEach((group) => {
      group.categories.forEach((inst) => {
        instructionMap[inst.categoryId] = inst;
      });
    });

    // Then, push into `ret` in the exact order of selectedProgram.instructions
    ret = selectedProgram.instructions
      .map((id) => instructionMap[id])
      .filter(Boolean);
  }

  return ret;
};

class EditProgram extends Component {
  constructor(props) {
    super(props);

    if (
      props.apps.providerAppId == undefined ||
      props.apps.providerAppId == null
    ) {
      //Go To Home Page
      const link = "/view-channels";
      props.history.push(link);
    }

    let programId = props.match.params.id;
    let selectedProgram = null;
    props.apps.appTemplates[props.apps.providerAppId].programs.forEach((p) => {
      if (p.programId === programId) {
        selectedProgram = p;
      }
    });

    this.state = {
      appId: props.apps.providerAppId,
      userId: props.user.userId,
      programId,
      canSearchByGroup: false,
      searchText: "",
      selectedProgram: selectedProgram,
      libraryInstructions: getInstructionsArray(props),
      instructions: getSelectedInstructionsArray(props, selectedProgram),
      newlySelected: [],
      programName: selectedProgram ? selectedProgram.programName : "",
      autopopulate:
        selectedProgram && selectedProgram.autopopulate
          ? selectedProgram.autopopulate
          : false,
      isAccordion:
        selectedProgram && selectedProgram.isAccordion !== undefined
          ? selectedProgram.autopopulate
          : false,

      //autopopulate: false,
      //isAccordion: false,
      onlyFavorites: false,
      saveDisabled: true,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.isAlreadyChecked = this.isAlreadyChecked.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  async handleSave() {
    if (this.state.programId) {
      let updatedProgram = { ...this.state.selectedProgram };
      updatedProgram.instructions = this.state.instructions.map(
        (i) => i.categoryId
      );
      updatedProgram.programName = this.state.programName;
      updatedProgram.isAccordion = this.state.accordion;
      updatedProgram.autopopulate = this.state.autopopulate;

      try {
        const response = await this.props.updateProgram(
          this.state.appId,
          this.state.userId,
          updatedProgram
        );
        this.props.history.goBack(); // Navigate only after update finishes
      } catch (err) {
        console.error("Update failed:", err);
      }
    } else {
      let newProgram = {
        programName: this.state.programName,
        autopopulate: this.state.autopopulate,
        instructions: this.state.instructions.map((i) => i.categoryId),
      };

      try {
        await this.props.addProgram(
          this.state.appId,
          this.state.userId,
          newProgram
        );
        this.props.history.goBack(); // Navigate after save
      } catch (err) {
        console.error("Program creation failed:", err);
      }
    }
  }

  handleCancel() {
    this.props.history.goBack();
  }

  isInFavorites(id) {
    if (
      this.props.apps &&
      this.props.apps.appFavorite &&
      this.props.apps.appFavorite.instructions
    ) {
      return this.props.apps.appFavorite.instructions.includes(id);
    } else {
      return false;
    }
  }

  handleDone() {
    let updatedInst = this.state.instructions;
    this.state.newlySelected.map((i) => {
      updatedInst.push(i);
      return true;
    });

    this.setState({
      newlySelected: [],
      instructions: updatedInst,
      modalOpen: false,
    });
  }

  isAlreadyChecked(id) {
    let filteredList = this.state.instructions.filter((i) => {
      return i.categoryId !== id;
    });
    return filteredList.length > 0;
  }

  handleRemove(id) {
    let filteredList = this.state.instructions.filter((i) => {
      return i.categoryId !== id;
    });
    this.setState({ instructions: filteredList });
  }

  handleSwitchChange(checked, instruction) {
    let instList = this.state.newlySelected;
    if (checked) {
      instList.push(instruction);
    } else {
      instList = instList.filter((i) => {
        return i.categoryId !== instruction.categoryId;
      });
    }
    this.setState({
      newlySelected: instList,
    });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  openModal() {
    this.setState({ modalOpen: true });
  }
  renderSelectedProgram() {
    return null;
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    let updatedOrder = arrayMove(this.state.instructions, oldIndex, newIndex);
    this.setState({
      instructions: updatedOrder,
    });
  };

  render() {
    return (
      <AppFrame>
        <Title
          text2={this.state.programId ? "Edit Program" : "Create Program"}
          goBack={() => this.props.history.goBack()}
          whiteLabelSettings={this.props.whiteLabelSettings}
        />
        <div className="page">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              marginTop: "50px",
              width: "900px",
            }}
          >
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div style={{ flexDirection: "row" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{
                    backgroundColor:
                      this.state.instructions.length == 0
                        ? colors.grey
                        : colors.primary,
                    color: colors.white,
                    marginRight: 15,
                  }}
                  onClick={this.handleSave}
                  disabled={this.state.instructions.length == 0}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={this.handleCancel}
                >
                  Cancel
                </Button>
              </div>
              <div>
                <Button
                  variant="outlined"
                  color="secondary"
                  style={{
                    marginRight: 15,
                  }}
                  onClick={this.openModal}
                  startIcon={<AddIcon />}
                >
                  Add Instruction
                </Button>
              </div>
            </div>
            <Paper
              style={{
                margin: 30,
                padding: 20,
                borderColor: colorsV2.primary,
                borderWidth: 2,
                borderStyle: "solid",
              }}
              elevation={3}
            >
              <h1 style={{ marginTop: 5, fontSize: 18 }}>Program Details</h1>
              <TextField
                label="Program Name"
                variant="outlined"
                value={this.state.programName}
                onChange={(e) => {
                  this.setState({ programName: e.target.value });
                }}
                style={{ width: "100%" }}
                helperText="Enter the name of your program"
              />
              <Paper
                style={{
                  marginTop: 10,
                  padding: 10,
                  borderColor: colors.lightGrey,
                  borderWidth: 1,
                  borderStyle: "solid",
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      name="autopopulate"
                      checked={this.state.autopopulate}
                      onChange={(val) => {
                        const curVal = this.state.autopopulate;
                        this.setState({ autopopulate: !curVal });
                      }}
                      color="primary"
                    />
                  }
                  label="Assign This Program To Every New Patient/Client"
                />
              </Paper>
            </Paper>
            <div>
              <SortableContainer onSortEnd={this.onSortEnd}>
                {this.state.instructions.map((item, index) => (
                  <SortableItem
                    key={`item-${item}`}
                    instruction={this.state.instructions}
                    index={index}
                    value={item}
                    handleRemove={this.handleRemove}
                  />
                ))}
              </SortableContainer>
            </div>
          </div>
        </div>

        <Dialog
          onClose={this.closeModal}
          aria-labelledby="customized-dialog-title"
          open={this.state.modalOpen}
          fullScreen={true}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.closeModal}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              Select Instructions To Add To Program
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Button
                  onClick={this.handleDone}
                  style={{
                    justifySelf: "flex-end",
                    backgroundColor: colors.primary,
                    color: colors.white,
                    marginRight: 15,
                  }}
                >
                  Add Selected Instructions
                </Button>
                <Button
                  onClick={this.closeModal}
                  style={{
                    justifySelf: "flex-end",
                    backgroundColor: colors.white,
                    borderColor: colors.primary,
                    border: "solid 1px",
                    color: colors.primary,
                    marginRight: 15,
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
                <TextField
                  id="filled-full-width"
                  label="Search"
                  type="search"
                  style={{ margin: 8 }}
                  placeholder={
                    this.state.canSearchByGroup
                      ? "Search By Category"
                      : "Search By Name"
                  }
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  value={this.state.searchText}
                  onChange={(e) => {
                    this.setState({ searchText: e.target.value });
                  }}
                />
              </div>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.showAll}
                    onChange={(val) => {
                      const curVal = this.state.canSearchByGroup;
                      this.setState({ canSearchByGroup: !curVal });
                    }}
                    name="toggleAll"
                    color="primary"
                  />
                }
                label="Search By Category"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.onlyFavorites}
                    onChange={(val) => {
                      const curVal = this.state.onlyFavorites;
                      this.setState({ onlyFavorites: !curVal });
                    }}
                    name="toggleAll"
                    color="primary"
                  />
                }
                label="Show My Favorites"
              />
            </div>
            {this.state.libraryInstructions
              .filter((item) => {
                let allowItem = true;
                this.state.instructions.forEach((i) => {
                  if (i.categoryId === item.categoryId) {
                    allowItem = false;
                  }
                });
                return allowItem;
              })
              .filter((item) => {
                if (this.state.canSearchByGroup) {
                  return item.groupName
                    .toLowerCase()
                    .includes(this.state.searchText.toLowerCase());
                } else {
                  return item.categoryName
                    .toLowerCase()
                    .includes(this.state.searchText.toLowerCase());
                }
              })
              .filter((item) => {
                if (this.state.onlyFavorites) {
                  return this.isInFavorites(item.categoryId);
                } else {
                  return true;
                }
              })
              .map((inst) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      border: "solid 1px grey",
                      borderRadius: 7,
                      margin: 10,
                      padding: 5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      <div style={{ margin: 0 }}>
                        {this.isInFavorites(inst.categoryId) ? (
                          <StarIcon
                            fontSize="small"
                            style={{ color: "orange" }}
                          />
                        ) : (
                          <StarBorderIcon fontSize="small" />
                        )}
                        <span
                          style={{
                            fontSize: 16,
                            fontFamily: "Poppins-Semibold",
                            marginRight: 30,
                          }}
                        >
                          {inst.categoryName}
                        </span>
                        <span
                          style={{
                            margin: 0,
                            padding: 5,
                            backgroundColor: colors.primary,
                            color: colors.white,
                            borderRadius: 5,
                            fontSize: 12,
                            fontFamily: "Poppins-Regular",
                          }}
                        >
                          {inst.groupName}
                        </span>
                      </div>
                      <Switch
                        onChange={(event) => {
                          this.handleSwitchChange(event.target.checked, inst);
                        }}
                      />
                    </div>
                    <p style={{ margin: 0, fontSize: 12, color: colors.grey }}>
                      {inst.categoryDesc}
                    </p>
                  </div>
                );
              })}
          </DialogContent>
        </Dialog>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, library }) {
  return {
    user,
    apps,
    library,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProgram);



// WEBPACK FOOTER //
// ./src/layout/EditProgram.js